import { Link } from "react-router-dom";
import { Phone, ChatText, EnvelopeSimple, MapPin } from "@phosphor-icons/react";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="border-t-2 border-line bg-surface" data-testid="footer">
    <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6">
      <div className="flex flex-col gap-10 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <div className="flex items-center gap-3">
            <Logo className="h-9 w-9" />
            <span className="font-display text-lg font-bold uppercase tracking-tight">
              Niagara <span className="text-safety">Callback</span>
            </span>
          </div>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-smoke">
            Missed-call text-back for home-services contractors. Run by Carlo Vescio in Niagara
            Falls, Ontario.
          </p>
        </div>
        <div className="flex flex-col gap-1">
          <a
            href="tel:+19053517489"
            data-testid="footer-call-link"
            className="flex min-h-[44px] items-center gap-3 font-semibold text-white transition-colors duration-200 hover:text-safety"
          >
            <Phone weight="bold" className="h-5 w-5 shrink-0 text-safety" aria-hidden="true" />
            905-351-7489
          </a>
          <a
            href="sms:+19053517489"
            data-testid="footer-text-link"
            className="flex min-h-[44px] items-center gap-3 font-semibold text-white transition-colors duration-200 hover:text-safety"
          >
            <ChatText weight="bold" className="h-5 w-5 shrink-0 text-safety" aria-hidden="true" />
            Text 905-351-7489
          </a>
          <a
            href="mailto:carlo@niagaracallback.ca"
            data-testid="footer-email-link"
            className="flex min-h-[44px] items-center gap-3 font-semibold text-white transition-colors duration-200 hover:text-safety"
          >
            <EnvelopeSimple weight="bold" className="h-5 w-5 shrink-0 text-safety" aria-hidden="true" />
            carlo@niagaracallback.ca
          </a>
          <p
            data-testid="footer-address"
            className="flex min-h-[44px] items-center gap-3 text-sm leading-relaxed text-smoke"
          >
            <MapPin weight="bold" className="h-5 w-5 shrink-0 text-safety" aria-hidden="true" />
            8605 Glavcic Drive, Niagara Falls, Ontario L2H 0B1
          </p>
        </div>
      </div>
      <p
        data-testid="footer-sms-notice"
        className="mt-10 max-w-2xl border-t-2 border-line pt-6 text-sm leading-relaxed text-smoke"
      >
        SMS notice. When you call Niagara Callback and we can't answer, we reply by text to the
        number you called from. Message and data rates may apply. Reply STOP to opt out at any
        time.
      </p>
      <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-smoke">
          © 2026 Niagara Callback · Niagara Falls, Ontario · niagaracallback.ca
        </p>
        <div className="flex gap-6">
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="flex min-h-[44px] items-center font-mono text-xs uppercase tracking-[0.2em] text-smoke transition-colors duration-200 hover:text-safety"
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="flex min-h-[44px] items-center font-mono text-xs uppercase tracking-[0.2em] text-smoke transition-colors duration-200 hover:text-safety"
          >
            Terms of Service
          </Link>
        </div>
      </div>
    </div>
  </footer>
);
